exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.pickup[data-v-69f8161a] {\n  max-width: 500px;\n}\n.icon[data-v-69f8161a] {\n  margin-right: 10px;\n}\n", ""]);

